import { useTranslation } from "react-i18next";
import SEOHead from "../components/shared/SEOHead.jsx";
import JsonLd from "../components/shared/JsonLd.jsx";
import { buildBreadcrumbJsonLd } from "../utils/jsonld.js";
import SimplePage from "../components/shared/SimplePage.jsx";

const PRESS_PATH = { de: "presse", en: "press" };

/** Placeholder — actual downloadable assets (logo pack, photos, fact sheet) don't exist yet. */
export default function Press({ lang }) {
  const { t } = useTranslation();

  return (
    <>
      <SEOHead
        lang={lang}
        path={`/${PRESS_PATH[lang]}`}
        altPath={`/${PRESS_PATH[lang === "de" ? "en" : "de"]}`}
        title={t("press.title")}
        description={t("press.intro")}
      />
      <JsonLd
        data={buildBreadcrumbJsonLd(
          [
            { name: t("nav.home"), path: "/" },
            { name: t("press.title"), path: `/${PRESS_PATH[lang]}` },
          ],
          lang
        )}
      />
      <SimplePage title={t("press.title")}>
        <p style={{ fontSize: "16px", lineHeight: 1.7, color: "rgba(10,9,7,0.72)", margin: 0 }}>{t("press.intro")}</p>
        <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: "10px" }}>
          <li className="placeholder" style={{ fontSize: "14px", color: "rgba(10,9,7,0.7)" }}>
            {t("press.logoPackPlaceholder")}
          </li>
          <li className="placeholder" style={{ fontSize: "14px", color: "rgba(10,9,7,0.7)" }}>
            {t("press.factSheetPlaceholder")}
          </li>
          <li className="placeholder" style={{ fontSize: "14px", color: "rgba(10,9,7,0.7)" }}>
            {t("press.photosPlaceholder")}
          </li>
        </ul>
        <p style={{ fontSize: "16px", lineHeight: 1.7, color: "rgba(10,9,7,0.72)", margin: 0 }}>
          {lang === "de" ? (
            <>
              Bei Fragen wendet euch gerne an{" "}
              <a href="mailto:presse@talesandlegends.org">presse@talesandlegends.org</a>.
            </>
          ) : (
            <>
              For questions, feel free to reach out to{" "}
              <a href="mailto:presse@talesandlegends.org">presse@talesandlegends.org</a>.
            </>
          )}
        </p>
      </SimplePage>
    </>
  );
}

export { PRESS_PATH };
